<template>
    <div>
        <div class="acitve-items" >
							<div class="active-items-title-read">
								<div class="active-item-title on-show-two">{{row.title}}</div>
								<div class="active-itme-read">
									<span v-for="(cate,i) in row.cate_list" :key="i">{{cate.name}}</span>
									<span>{{row.views_count}}阅读</span></div>
							</div>
							
						</div>
    </div>
</template>

<style scoped>
    /* 无图 */
	.acitve-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;display: flex;justify-content: space-between;}
	.active-items-title-read{display: flex;justify-content: space-between;flex-direction: column;}
.active-item-title{
		 
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1); 
	}
	 
	.acitve-item-title{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
	}
	.active-itme-read{ 
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
		margin-top: 0.2rem;
	}
    
</style>

<script>
    export default {
        name: "NewsItem1",
        components: {
        },
        props: {
			row: {
				type: Object,
				default: {
					title:'',
					cate_list:[]
				}
			}

        },

        data: function () {
            return {}
        },

        methods: {
            
        },

        filters: {}

    };
</script>




// WEBPACK FOOTER //
// NewsItem1.vue?2f3bcdfe